<form [formGroup]="processInfoFormGroup">
    <div class="standard-flange-edit-section">
        <div class="process_input_sec">
            <div>
                <mat-label class="font-style" [ngbTooltip]="operatingTemp_tooltip" placement="right" container="body"
                    tooltipClass="custom-tooltip">
                    <!-- Operating Temperature -->
                    {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.OPERATING_TEMPERATURE' | transloco }}
                </mat-label>
                <!--tool-tip template start-->
                <ng-template #operatingTemp_tooltip>
                    <p>
                        {{ 'TOOLTIP.INFORMATE_CALC_LABELS.OPERATING_TEMPERATURE' | transloco }}
                    </p>
                </ng-template>

                <input class="input-form-class" matInput type="text" formControlName="operatingTemp"
                    name="operating_temp" [matTooltip]="
                        processInfoFormGroup.get('operatingTemp').hasError('required')
                            ? 'Operating Temperature is required. '
                            : 'Exceeding 1000 °C (1832 °F)  is not recommended, contact your local Technical Support for future information'
                    " [matTooltipDisabled]="processInfoFormGroup.get('operatingTemp').valid"
                    (change)="onBlurOptTemp($event, 0)" [class.select-disable]="enable"
                    [ngClass]="processInfoFormGroup.get('operatingTemp').valid ? '' : 'highLight'" />
            </div>

            <div>
                <mat-label class="font-style" [ngbTooltip]="operatingPressure_tooltip" placement="right"
                    container="body" tooltipClass="custom-tooltip">
                    <!-- Operating Pressure -->
                    {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.OPERATING_PRESSURE' | transloco }}
                </mat-label>

                <ng-template #operatingPressure_tooltip>
                    <p>
                        {{ 'TOOLTIP.INFORMATE_CALC_LABELS.OPERATING_PRESSURE' | transloco }}
                    </p>
                </ng-template>

                <input class="input-form-class" matInput type="text" formControlName="operatingPressure"
                    (blur)="onBlurEvent($event, 1)" #tooltip="matTooltip" [matTooltip]="
                        processInfoFormGroup.get('operatingPressure').hasError('required')
                            ? 'Oprating pressure is required. '
                            : 'Oprating pressure  higher than allowed. '
                    " [matTooltipDisabled]="processInfoFormGroup.get('operatingPressure').valid"
                    [class.select-disable]="enable"
                    [ngClass]="processInfoFormGroup.get('operatingPressure').valid ? '' : 'highLight'" />
            </div>

            <div>
                <mat-label class="font-style" [ngbTooltip]="testPressure_tooltip" placement="right" container="body"
                    tooltipClass="custom-tooltip">
                    <!-- Test Pressure -->
                    {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.TEST_PRESSURE' | transloco }}
                </mat-label>
                <!--tool-tip template start-->
                <ng-template #testPressure_tooltip>
                    <p>
                        {{ 'TOOLTIP.INFORMATE_CALC_LABELS.TEST_PRESSURE' | transloco }}
                    </p>
                </ng-template>
                <!--tool-tip template end-->

                <input class="input-form-class" matInput type="text" formControlName="testPressure"
                    (blur)="onBlurEvent($event, 2)" #tooltip="matTooltip" [matTooltip]="
                        processInfoFormGroup.get('testPressure').hasError('required') ? 'Test pressure is required. ' : 'Test pressure  higher than allowed. '
                    " [matTooltipDisabled]="processInfoFormGroup.get('testPressure').valid"
                    [class.select-disable]="enable"
                    [ngClass]="processInfoFormGroup.get('testPressure').valid ? '' : 'highLight'" />
            </div>
        </div>

        <div class="" *ngIf="idmsSharedService.enableConfirmWithRouter(1)">
            <a href="javascript:void(0)" class="btn font-weight-bold py-3 px-6 secondary-ebtn informateFullWidth"
                (click)="btnProcessInfoConfirmClicked()">
                <!-- Confirm -->
                {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CONFIRM' | transloco }}
            </a>
        </div>
    </div>
</form>